var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "38.555 37.555 135.31 135.891",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.2984 44.1015C103.027 40.7426 116.486 41.4235 128.811 46.0488L122.579 62.6552C113.696 59.322 103.997 58.8311 94.8238 61.2519C85.6504 63.6727 77.4558 68.8848 71.3746 76.167C65.2933 83.4492 61.6258 92.4423 60.8794 101.9C60.1332 111.358 62.345 120.814 67.2085 128.96C72.0723 137.106 79.3477 143.539 88.0279 147.369C96.7081 151.199 106.364 152.236 115.66 150.337C124.955 148.438 133.431 143.697 139.914 136.769C146.396 129.842 150.566 121.072 151.845 111.671L169.42 114.063C167.645 127.108 161.86 139.278 152.865 148.89C143.869 158.502 132.108 165.081 119.21 167.716C106.311 170.351 92.9123 168.911 80.8677 163.597C68.8234 158.283 58.7279 149.357 51.9791 138.054C45.2302 126.75 42.1612 113.629 43.1968 100.505C44.2325 87.3808 49.322 74.9026 57.7603 64.7978C66.1986 54.6931 77.5694 47.4606 90.2984 44.1015ZM146.789 66.8086C148.912 64.6374 152.394 64.5985 154.566 66.7216C156.738 68.8453 156.776 72.3282 154.653 74.5L107.78 122.435L103.435 126.878L99.5523 122.024L81.1568 99.0302C79.2596 96.6583 79.6444 93.1972 82.0162 91.2998C84.3879 89.4026 87.8491 89.7868 89.7466 92.1582L104.259 110.3L146.789 66.8086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAvailability);
export default __webpack_public_path__ + "static/media/team_availability.3052166fe8912de00e11ad0db0516fd8.svg";
export { ForwardRef as ReactComponent };